/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'hr': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M17.35 9.22a5.45 5.45 0 0 0-5.52 5.4c0 2.93 2.43 5.4 5.52 5.4a5.45 5.45 0 0 0 5.5-5.4c0-2.94-2.41-5.4-5.5-5.4zm-9.7 5.4A9.66 9.66 0 0 1 17.35 5c5.3 0 9.7 4.26 9.7 9.62a9.66 9.66 0 0 1-9.7 9.61c-5.31 0-9.7-4.26-9.7-9.61zm38.75 2.27c.81.84.8 2.17-.03 2.99l-7.6 7.5c-.82.8-2.11.8-2.93 0l-3.8-3.75a2.13 2.13 0 0 1-.03-2.98c.8-.84 2.13-.85 2.96-.04l2.34 2.31 6.14-6.06c.82-.81 2.15-.8 2.95.03zM3.86 30.32a9.73 9.73 0 0 1 6.83-2.8H24c2.56 0 5.02 1 6.84 2.8a9.58 9.58 0 0 1 2.85 6.82v3.75A2.1 2.1 0 0 1 31.6 43a2.1 2.1 0 0 1-2.09-2.11v-3.75c0-1.42-.57-2.79-1.6-3.8a5.57 5.57 0 0 0-3.91-1.6H10.7c-1.48 0-2.89.58-3.92 1.6a5.34 5.34 0 0 0-1.6 3.8v3.75A2.1 2.1 0 0 1 3.1 43 2.1 2.1 0 0 1 1 40.89v-3.75a9.58 9.58 0 0 1 2.86-6.82z"/>'
  }
})
